import { useState, useEffect } from 'react';

/**
 * Hook for fetching scheduled calls for a conversation
 * @param {string|number} conversationId - Conversation ID
 * @returns {Object} Scheduled calls, loading state, and error
 */
const useFetchScheduledCalls = (conversationId) => {
  const [scheduledCalls, setScheduledCalls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchScheduledCalls = async () => {
      if (!conversationId) {
        setScheduledCalls([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/scheduled-calls/conversation/${conversationId}`,
          {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setScheduledCalls(data.data || []);
        } else {
          setError('Error fetching scheduled calls');
          setScheduledCalls([]);
        }
      } catch (err) {
        setError(err.message);
        setScheduledCalls([]);
      } finally {
        setLoading(false);
      }
    };

    fetchScheduledCalls();
  }, [conversationId]);

  return {
    scheduledCalls,
    setScheduledCalls,
    loading,
    error
  };
};

export default useFetchScheduledCalls;

